module.exports = __webpack_public_path__ + "img/1.84c4eb88.png";